import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
/*
import comingSoon from './components/pages/comingSoon';
*/
import home from './components/pages/home';
import biz from './components/pages/biz';
import salon_list from './components/pages/salon-list';
import salon from './components/pages/salon';
import uvjeti from './components/pages/uvjeti';
import privatnost from './components/pages/privatnost';
import cestaPitanja from './components/pages/cesta-pitanja';
import kakoRezervirati from './components/pages/kako-rezervirati';
import kontakt from './components/pages/kontakt';
// import reset from './components/pages/reset';

import userDashboard from './components/pages/user/index';
import vendorTermini from './components/pages/vendor/index';

const router = new Router({
	mode: 'history',
		scrollBehavior(to) {
		if (to.hash) {
			return {
				selector: to.hash,
			}
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [
		{
			path: '/',
			component: home,
        },
		{
			path: '/business',
			component: biz
        },
		{
			path: '/uvjeti',
			component: uvjeti
        },
		{
			path: '/privatnost',
			component: privatnost
        },
		{
			path: '/cesta-pitanja',
			component: cestaPitanja
        },
		{
			path: '/kako-rezervirati',
			component: kakoRezervirati
        },
		{
			path: '/kontakt',
			component: kontakt
        },
		{
			path: '/salon-list',
			component: salon_list
        },
		{
			path: '/salon/:name',
			name: 'salon',
			component: salon,
        },/*
		{
			path: '/reset-password/:token',
			component: home,
			name: 'reset_password'
        },*/
        // {
        //     path:'/reset',
        //     component:reset, 
        //     name:'reset'
        // },
		{
			path: '/user',
			component: userDashboard,
			meta: {
				AuthRequired: true
			}
        },
		{
			path: '/vendor',
			component: vendorTermini,
			meta: {
				AuthRequired: true
			}
        },/*
		{
			path: '/reset-password/:token',
			component: home,
        },*/
    ],
});

export default router;

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.AuthRequired)) {
		if (localStorage.getItem('data') == null) {
			next({
				path: '/',
			})
		} else {
			var data = JSON.parse(localStorage.getItem('data'));
			console.log(to);
			if (to.path == '/vendor' && data.user.vendor == null) {
				next({
					path: '/user',
				});
			} else if (to.path == '/user' && data.user.vendor != null) {
				next({
					path: '/vendor',
				});
			} else {
				next();
			}
		}
	}

	next();
})
